<!--
  name : 김혜진
  desc : 계약요청 목록 확인
  date : 2021-08-04
-->
<template>
  <v-row no-gutters>

    <!--내용-->
    <v-col cols="12" class="write_conYscroll">
      <v-row no-gutters class="row_mb-40">
        <v-col cols="12">
          <v-row no-gutters class="PasFail_round_box">
            <v-col cols="12" class="posiR">
              <ul class="PasFail_Con">
                <li v-if="contract.sucCnt > 0">
                  <v-chip class="pasFail-chip">성공</v-chip>
                  <span class="txt_txt01">{{contract.sucCnt}}</span>
                  <span class="txt_txt02">건</span>
                </li>
                <li v-if="contract.failCnt > 0">
                  <v-chip class="pasFail-chip stFail">실패</v-chip>
                  <span class="txt_txt01">{{contract.failCnt}}</span>
                  <span class="txt_txt02">건</span>
                </li>
                <li>
                  <span class="fc_b03">/</span>
                </li>
                <li>
                  <span class="txt_name">[{{this.contract.contractName + ' ' + (contract.totalCnt) + '건'}}]</span>
                  <span class="fc_b03"> 사내계약 파일명은</span>
                  <span>[{{this.contract.contractName}}_아이디_이름]</span>
                  <span class="fc_b03"> 형식만 가능합니다.</span>
                </li>
              </ul>
              <v-btn text class="btn17_C01 PasFail_ConN_btn" @click="beforeUpload()">계약 추가</v-btn>
              <v-row no-gutters class="contractRe_con" v-if="reUploadCheck">
                <v-col cols="10">
                  <v-file-input
                    class="inputH48_01 W100W Hauto"
                    ref="contractUpload"
                    :rules="rules.fileUploadRules"
                    :accept="upload.uploadCtrPaperAccept"
                    label="계약서 파일"
                    v-model="reUploadFile"
                    outlined
                    chips
                    dense
                    multiple
                    >
                  </v-file-input>
                  <v-btn text class="btn17_C01 btn_addWCpn_cerList" v-if="reUploadCheck" @click="retryUpload()">업로드</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div class="txtst_info_red row_mb-20">
            - 성공한 업로드 건만 계약요청 됩니다. 실패 건은 확인 후 다시 업로드해 주세요.
          </div>
        </v-col>

        <v-col>
          <!--List-->
          <v-row no-gutters class="pasFail_list">
            <v-col cols="12" sm="12" md="12" lg="12">

              <v-card v-for="(officeContractList, index) of officeContractList" :key="index" class="pasFail_carD">
                <v-row no-gutters>
                  <v-col class="pFlist_num" cols="2">{{index + 1}}</v-col>
                  <v-col class="pFlist_con">

                    <!--status==='fail'-->
                    <div class="row_01" v-if="officeContractList.status==='fail'">
                      <div class="carD_chip00">
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <v-chip class="pasFail-chip stFail">실패</v-chip>
                            </div>
                          </template>
                          <div>{{officeContractList.message}}</div>
                        </v-tooltip>
                      </div>
                      <!--FileName-->
                      <div class="txt_01">
                        <span class="st_tt_01">{{officeContractList.contractFileName}}</span>
                      </div>
                    </div>

                    <!--status==='success'-->
                    <div class="row_01" v-if="officeContractList.status==='success'">
                      <div class="carD_chip00">
                        <v-chip class="pasFail-chip stSuccess">성공</v-chip>
                      </div>
                      <!--FileName-->
                      <div class="txt_01">
                        <span class="st_tt_01">{{officeContractList.contractFileName}}</span>
                      </div>
                    </div>

                    <!--sender / receiver-->
                    <div class="row_02">
                      <ul class="pattern_ulTxtBox">
                        <li>
                          <span class="txt_icon">요청</span>
                          <span class="txt_txt02 no_pr">{{officeContractList.senderOrg}}</span>
                        </li>
                        <li>
                          <span class="txt_icon icon_C02">요청 대행자</span>
                          <span class="txt_txt02 no_pr">{{officeContractList.sender}}</span>
                        </li>
                        <li>
                          <span class="txt_icon">수신</span>
                          <span class="txt_txt02 no_pr">{{officeContractList.receiver}}</span>
                        </li>
                      </ul>
                    </div>
                  </v-col>
                  <!--Button-->
                  <v-col class="btnCon_pFlist-del">
                    <v-btn icon class="btnO_C04 delete" @click="deleteContractInfos(index, officeContractList.saveCtrId)"><span class="icon">삭제</span></v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class="pFlist_num" cols="2"></v-col>
                  <div class="txtst_info_red row_mb-20">
                    {{officeContractList.message}}
                  </div>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
        </v-col>

      </v-row>

      <!-- 첨부파일 -->
      <!-- <v-row no-gutters class="row_mb-40">
        <v-col cols="12" class="mt-5">
          <v-file-input class="inputH48_01 W100W Hauto"
            label="첨부파일"
            placeholder=" "
            :rules="rules.attachFileUploadRules"
            :accept="upload.uploadCtrPapaerAttachAccept"
            outlined
            chips
            multiple
            dense
						ref="ctrPaperAttachUpload" v-model="attachFiles"
            @change="chkPaperAttachFileUpload"
          >
					<template v-slot:selection="{ text }">
						<v-chip
							small
							label
							color="primary"
						>
							{{ text }}
						</v-chip>
					</template>
					</v-file-input>
        </v-col>
      </v-row> -->

      <!-- 부가정보 -->
      <v-row no-gutters class="row_mb-40">
        <div class="dot_tt">부가정보 등록</div>
        <div class="txtst_info_gray">계약과 관련된 부가정보를 입력해주세요.</div>
        <v-col cols="12" class="mt-5">
          <v-row no-gutters class="coNlistCon_sideInfo">

            <!-- List -->
            <v-col v-for="(info, i) in infos" :key="i" cols="12" class="coNlist_receiverCpn">
              <v-card class="carD_sideInfo">
                <v-form ref="metaForm" lazy-validation>
                  <ul class="pattern_ulTxtBox">
                    <li>
                      <v-text-field ref="activeRules" class="inputH48_03"
                        label="제목"
                        v-model="info.key"
                        :rules="active_rules"
                        required
                      >
                      </v-text-field>
                    </li>
                    <li>
                      <v-text-field class="inputH48_03"
                        label="내용"
                        v-model="info.value"
                      ></v-text-field>
                    </li>
                  </ul>
                  <div class="btnCon_carD_receiv">
                    <v-btn icon class="btnO_C04 delete" @click="deleteSubInfo(i)"><span class="icon">삭제</span></v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-col>

            <!-- 부가정보 없을 때 -->
            <div v-if="infos.length == 0" class="list_no_txt02">
              등록된 부가정보가 없습니다.
            </div>

          </v-row>
          <v-btn text class="btn17_C01" v-if="this.infos.length < 5" @click="add()"><span class="icon"></span>부가정보 추가</v-btn>
        </v-col>
      </v-row>
    </v-col>

  <!-- ** Popup ** -->

  <!--(Popup)계약 요청-->
	<v-dialog
    v-model="dialogWcpn"
    max-width="800px"
    persistent>
    <v-card id="popStyle03">
      <v-card-title class="title">
        계약요청
        <v-btn fab class="popBtnClose" @click="dialogWcpn = false"></v-btn>
      </v-card-title>

      <v-card-text>
        <v-row no-gutters class="justify-center popCon">
          <div class="dot_tt16 mb-2">계약 진행 상태</div>
          <v-col cols="12" class="next2step_end_logBox row_mb-40">
            <v-card-text class="box_log">
              <ul>
                <li>
                  <div class="box_log_txt">{{contract.sucCnt}}건의 사내 계약서가 업로드 되었습니다.</div>
                </li>
                <li>
                  <div>
                    <div class="box_log_txt">
                      {{ successName }}에게 계약요청합니다.
                    </div>
                  </div>
                </li>
              </ul>
            </v-card-text>
          </v-col>
          <v-col cols="12" class="popaddMark_btnCon">
            <div class="dot_tt16 mb-2">
              <v-btn outlined class="btn17_00 btn_pAright" @click="openWmDialog()">서명/워터마크 첨부</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn text @click="officeContractNextStep()">확인</v-btn>
        <v-btn text @click="dialogWcpn = false">취소</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--(Popup)서명/워터마크 첨부-->
  <v-dialog v-model="dialogWcpnWaterM" max-width="1200">
    <v-card id="popStyle03">

      <v-card-title class="title">
        서명/워터마크 첨부
        <v-btn fab class="popBtnClose" @click="dialogWcpnWaterM = false"></v-btn>
      </v-card-title>

      <v-card-text class='scrollYst mark_scrollCon'>
        <v-row no-gutters class="justify-center popCon scrollYst_con">
          <!-- 계약서 썸네일 -->
          <v-col cols="12" sm="12" md="6" lg="8" class="popMark_view_col">
            <v-row no-gutters class="popMark_view mt-0">
              <div class="wm-contract-container" align="center" style="overflow:hidden; height:auto; border:1px solid #dbdce1; float: left">
                <swiper :options="swiperOption" ref="contractSwiper">
                  <swiper-slide v-for="(thumbnail, pindex) in contractThumbnail.thumbnail" :key="pindex">
                    <!-- <img> -->
                    <img :id="'img-' + pindex" :src="thumbnail.url">
                    <vue-draggable-resizable
                    :w="100"
                    :h="100"
                    :minw="30"
                    :minh="30"
                    @dragging="onDrag"
                    @resizing="onResize"
                    @activated="onActive(cindex)"
                    @deactivated="onDeactivate(cindex)"
                    :parent="true"
                    v-show="showWm"
                    v-model="watermarks[pindex][cindex]"
                    v-for="(watermark, cindex) in watermarks[pindex]" :key="cindex">
                      <div :class="'pdfWatermark' + pindex + '-' + cindex" :width="watermark.width" :height="watermark.height" style="cursor: pointer;border: 1px dotted gray;"></div>
                    </vue-draggable-resizable>
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="4">
            <v-row no-gutters class="mt-0">
              <v-col cols="12" class="btnBox_mg_tbr">
                <v-btn class="btn18_00" outlined @click="signVisible = true">전자서명 등록</v-btn>
                <v-btn class="btn18_00" outlined @click="selectWatermark()">워터마크 등록</v-btn>
                <v-checkbox
                  v-model="contract.isAllPage"
                  label="모든 페이지 삽입"
                  @change="changeAllPageCheck"
                ></v-checkbox>
                <v-btn class="btn18_00" outlined  @click="initWatermark()">워터마크 초기화</v-btn>
              </v-col>
              <v-col cols="12">
                <ul class="pop_info_ul">
                  <li>워터마크는 드래그 하여 크기와 위치를 지정 할 수 있습니다. (QR코드는 오른쪽 상단에 고정됩니다)</li>
                  <li>사내계약은 계약서 1건에 워터마크를 첨부 하면 나머지 사내계약서에 워터마크가 일괄 등록됩니다.</li>
                </ul>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- Button -->
      <v-card-actions class="justify-center">
        <v-btn text @click="createWatermarkPdf()">확인</v-btn>
        <v-btn text @click="closeWmDialog()">취소</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--(Popup)워터마크 등록-->
  <v-dialog width="440px"  v-model="selWmVisible">
    <v-card id="popStyle03">
      <v-card-title class="title">
        워터마크 등록
      <v-btn fab class="popBtnClose" @click="selWmVisible = false"></v-btn>
      </v-card-title>

      <v-card-text class='scrollYst savemark_scrollCon'>
        <v-carousel v-if="wmList.length !== 0" :interval="4000" type="card" height="200px">
          <v-carousel-item v-for="(watermark, index) in wmList" :key="watermark.id">
            <v-card class="wm-watermark-card">
              <v-checkbox class="doc_type_chk"
                          v-model="wmCheckedList"
                          :value="index"
                          @click="getWaterMarkInfo(index)"
                          hide-details
              ></v-checkbox>
              <div v-if="wmList.length !== 0">
                <img :src="watermark.url" class="wm-watermark-img">
              </div>
            </v-card>
          </v-carousel-item>
        </v-carousel>
        <v-row no-gutters v-else class="wm-empty-container popCon">
          워터마크가 없습니다. 계약 정보 설정에서 등록해주세요.
        </v-row>
      </v-card-text>

      <v-card-actions class="wm-sig-btn-container justify-center">
        <v-btn text @click="clickWm">확인</v-btn>
        <v-btn size="medium" @click="selWmVisible = false">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--(Popup)전자서명 등록-->
  <v-dialog width="440px"  v-model="signVisible">
    <v-card id="popStyle03">
      <v-card-title class="title">
        전자서명 등록
      <v-btn fab class="popBtnClose" @click="signVisibleClose"></v-btn>
      </v-card-title>

      <v-card-text class='scrollYst savemark_scrollCon'>
        <insert-signature ref="signature" :visibleCheckBox='true'></insert-signature>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn text @click="registSignature">확인</v-btn>
        <v-btn text @click="signVisibleClose">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
  </v-row>
</template>
<script>
import { deleteUploadedCtr, pdfConversionRequestOfficeCtr, confirmUsePoint, retryUploadOfficeCtrFile } from '@/api/setting/officeContract'
import { registSignature, getWaterMarkList, createContract, createContractThumbnail, deleteContractThumbnail } from '@/api/contract/insertWatermark'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import insertSignature from '@/components/signature'
import VueDraggableResizable from 'vue-draggable-resizable'

import 'swiper/dist/css/swiper.css'

var URL = {
  thumbnail: process.env.VUE_APP_URL_THUMBNAIL,
  watermark: process.env.VUE_APP_URL_WATERMARK,
  insertBarcode: process.env.VUE_APP_URL_INSERT_BARCODE,
  fileDownload: process.env.VUE_APP_URL_CONVERT_FILE_DOWNLOAD,
  contractPageThumbnail: process.env.VUE_APP_URL_CONTRACT_PAGE_THUMBNAIL
}

export default {
  name: 'step02',
  components: {
    swiper,
    swiperSlide,
    insertSignature,
    VueDraggableResizable
  },
  filters: {
  },
  props:{
  },
  data () {
    return {
      rules: {
				fileUploadRules: [
					v => !!v || v.size < 10000000 || '10MB 이하의 파일만 선택 가능합니다.',
				],
				attachFileUploadRules: [
					v => !!v || v.size < 30000000 || '30MB 이하의 파일만 선택 가능합니다.',
				],
			},
      upload: {
        uploadCtrPaperAccept: '.jpg, .jpeg, .gif, .bmp, .png, .doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx',
        // uploadCtrPapaerAttachAccept: '.jpg, .jpeg, .gif, .bmp, .png, .doc, .docx, .pdf, .zip, .7z, .alz, .xls .xlsx, .ppt, .pptx',
        // fileCtrPaperAttachList: [],
        // uploadCtrPaperAttachExceed: 5, // 첨부파일 업로드 허용갯수
			},
      // 최대 계약서 업로드 갯수
      limitFileNum: 50,

      /** 다이얼로그 */
      dialogWcpn: false,  // 계약 요청
      signVisible: false,  // 전자서명 등록
      selWmVisible: false,  // 워터마크 등록
      reUploadCheck: false,  // 계약 추가 및 재업로드
      dialogWcpnWaterM: false,  // 서명/워터마크 첨부

      /** 파일 업로드 */
      officeContractInfos: [],  // 첫 번째 계약서 파일 업로드 후 리턴 받은 값 (계약 명, 업로드한 파일명, 수신자, 발신자 등등)
      fileData: new FormData(),  // 파일 업로드 format
      officeContractList: [],  // 업로드된 계약서 List
      contractStatus: 'OFFICE',  // 계약종류
      contract: {  // 업로드할 계약서 성공 / 실패 / 총 갯수
        isAllPage: false,
        sucCnt: 0,
        failCnt: 0,
        totalCnt: 0,
        contractName: ''
      },
      convertedInfo: {  // PDF로 변환된 파일 정보
        convertedCtrFileName: null,
        contractNumber: null
      },
      firstCtrInfo: {  // 첫 번째 계약서 파일 정보 (첫 번째 파일을 대표로 워터마크 찍기위해 변환 시킴)
        ctrFileName: null,
        qrcodeFileName: null,
        filePath: null,
        contractNumber: null,
        groupId: null
      },

      /** 업로드 성공 list */
      successName: [],  // 수신자 이름
      successContract: [],  // 계약서 List

      /** 파일 재업로드 */
      reUploadFile: [],  // 재 업로드 할 파일 List

      /** 부가정보 */
      infos: [],  // 부가정보
      active_rules: [  //  부가정보 문자열 조건
        v => !!v || '필수값 입니다.',
        v => !/[0-9]/.test(v.charAt(0)) || '첫문자 숫자 불가',  // v.charAt(0) null 값 때문에 consol에서 에러
        v => !/[~!@#$%^&*()_+|<>?:{}]/.test(v) || '특수문자 불가',
        v => !/[\s]/g.test(v) || '공백 불가'
      ],

      /** 워터마크 */
      wmList: [],  // 저장된 워터마크 List
      watermarks:[],  // 선택한 워터마크 List
      wmCheckedList: [],  // Check List

      /** 썸네일 */
      pdfFileName: '',  // 썸네일 생성시 pdf 이름
      contractThumbnail: {  // 계약서 썸네일
        pageSize: null,
        thumbnail: []
      },
      swiperOption: {  // swiper 옵션
        autoHeight: true,
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      /** 첨부파일 */
			// attachFiles: [],  // 첨부파일
    }
  },
  created () {
  },
  mounted () {
    this.officeContractInfos = this.$store.state.app.officeContractInfos
    if(this.$store.state.user.orgaddr) {
      this.activeName = 'company'
    } else {
      this.activeName = 'personal'
    }
    this.UploadcontractNum ()
  },
  methods: {
    // 워터마크 체크 유무 함수
    getWaterMarkInfo (index) {
      this.wmList[index].isChecked = !this.wmList[index].isChecked
    },
    // 계약서 성공 / 실패 / 총 갯수 구하는 메서드
    UploadcontractNum () {
      var sucCnt = 0
      var failCnt = 0
      this.successName=[]
      this.officeContractList=[]
      var officeContractList=[]

      officeContractList = this.officeContractInfos[0].contractInfos

      for (var i in officeContractList) {
        this.officeContractList.push(officeContractList[i])
        if (officeContractList[i].status === 'success') {
          this.successContract.push(officeContractList[i])
          this.successName.push(officeContractList[i].receiver)
          sucCnt++
        } else if (officeContractList[i].status === 'fail') {
          failCnt++
        }
      }
      // 정렬할 Array의 요소의 개수가 2개 미만일 경우 ‘sort is not a function’ 오류
      if (this.officeContractList.length > 1) {
        // 업로드한 계약서 리스트중 실패한 리스트를 위로 올리도록 정렬
        this.officeContractList.sort(function (a, b) {
          if (b.status > a.status) return -1
          if (a.status > b.status) return 1
          return 0
        })
      }

      this.contract.sucCnt = sucCnt
      this.contract.failCnt = failCnt
      this.contract.totalCnt = sucCnt + failCnt
      this.contract.contractName = this.officeContractInfos[0].contractName
      this.officeContractInfos[0].contractInfos = []
      for (var j in this.officeContractList) {
        this.officeContractInfos[0].contractInfos.push(this.officeContractList[j])
      }
    },

    // 계약서 테이블에서 계약서 컬럼 삭제하는 함수
    deleteContractInfos (index, saveCtrId) {
      if (this.officeContractList.length > 0) {
        this.$refs.confirm.open('confirm','계약파일 삭제', this.officeContractList[index].contractFileName + ' 계약서를 계약리스트에서 제외하시겠습니까?').then(() => {
          if (this.officeContractList[index].status === 'success') {
            deleteUploadedCtr({ saveCtrId: saveCtrId }).then(response => {
              if (response.rdata.rcode === 20000) {
                this.officeContractInfos[0].contractInfos.splice(index, 1)
              } else {
                this.$refs.confirm.open('alert','사내계약', '계약서 삭제에 실패했습니다. ( error : ' + response.rdata.rmessage + ' )')
              }
              this.UploadcontractNum()
            }).catch(e => {
              console.error(e)
            })
          } else {
            this.officeContractInfos[0].contractInfos.splice(index, 1)
            this.UploadcontractNum()
          }
        })
      } else {
        this.$refs.confirm.open('alert','사내계약', '계약서 수신정보는 최소 1개이상이여야 합니다.')
      }
    },

    deleteAllContract () {
      this.deleteUploadedCtr()
      this.UploadcontractNum()
    },

    deleteUploadedCtr () {
      for (var i in this.officeContractList) {
        if (this.officeContractList[i].status === 'success') {
          deleteUploadedCtr({ saveCtrId: this.officeContractList[i].saveCtrId }).then(response => {
            if (response.rdata.rcode === 20000) {
              this.officeContractInfos[0].contractInfos.splice(i, 1)
            } else {
              this.$refs.confirm.open('alert','사내계약', '계약서 삭제에 실패했습니다. ( error : ' + response.rdata.rmessage + ' )')
            }
          }).catch(e => {
            console.error(e)
          })
        } else {
          this.officeContractInfos[0].contractInfos.splice(i, 1)
        }
      }
    },

    // 부가정보 추가
    add () {
      this.infos.push({ key: this.t, active: true })
    },
    // 부가정보 삭제
    deleteSubInfo (index) {
      this.infos.splice(index, 1)
    },

    // 계약 추가 및 재업로드
    beforeUpload () {
      this.reUploadCheck = true
    },
    // 계약서 추가 및 재업로드 함수
    retryUpload () {
      if (this.reUploadFile.length > 0) {
        this.$refs.loading.start('계약서를 업로드 중입니다.')

        for (var i in this.reUploadFile) {
          var count = parseInt(this.contract.totalCnt) + parseInt(i) + 1
          if (count <= this.limitFileNum) { // 계약서 갯수 제한
            var ctrFile = new FormData()
            ctrFile.append('file', this.reUploadFile[i])
            ctrFile.append('groupId', this.officeContractInfos[0].groupId)
            ctrFile.append('contractName', this.officeContractInfos[0].contractName)

            retryUploadOfficeCtrFile(ctrFile).then(response => {
              this.$refs.loading.end()
              if (response.rdata.rcode === 20000) {
                this.officeContractInfos[0].contractInfos.push(response.rdata.contractInfo)
                this.reUploadFile=[]
                this.reUploadCheck = false
                this.UploadcontractNum()
              } else {
                this.$refs.confirm.open('alert','사내계약', '계약서 업로드에 실패했습니다.')
                this.reUploadFile=[]
              }
            }).catch(e => {
              console.error(e)
            })
          } else {
            this.$refs.loading.end()
            this.$refs.confirm.open('alert','계약파일 업로드', '계약서는' + this.limitFileNum + '건까지 업로드 할 수 있습니다.')
            this.reUploadCheck = false
            this.reUploadFile = []
          }
        }
      } else {
        this.$refs.confirm.open('alert','계약파일 업로드', '계약서를 선택해 주세요.')
      }
    },

    // 부가정보 유효성 체크 / 성공파일 개수 count
    checkUploadCtrAndSubInfo () {
      var checkRules = true
      for (var i in this.infos) {
        if (!this.$refs.activeRules[i].validate()) {
          checkRules = false
        }
      }
      if (checkRules) {
        var sucCnt = 0
        for (var j in this.officeContractInfos[0].contractInfos) {
          if (this.officeContractInfos[0].contractInfos[j].status === 'success') {
            sucCnt++
          }
        }
        if (sucCnt > 0) {
          this.uploadIsSuccessCtr()
        } else {
          this.$refs.confirm.open('alert','사내계약요청', '업로드한 계약서 중 1건 이상 성공한 계약서가 있어야 계약 요청을 하실 수 있습니다.')
        }
      } else {
        this.$refs.confirm.open('alert', '부가정보 저장', '부가 정보 형식을 확인해주세요.')
      }
    },

    // 계약서 업로드 성공 / 실패 보여주는 알람창 후 결제 정보 보여주는 창 떠야함
    uploadIsSuccessCtr () {
      var useMsg = null
      var defaultMsg = null

      useMsg = '<div class="row_mb-8">- 계약 요청 리스트 테이블</div>'
      useMsg += ' <table class="basic_view">'
      useMsg += ' <colgroup><col style="width:40%"/><col style="width:60%"/></colgroup>'
      useMsg += ' <tbody>'
      useMsg += ' <tr><th scope="row">업로드 성공 계약서</th><td>' + this.contract.sucCnt + ' 건</td></tr>'
      useMsg += ' <tr><th scope="row">업로드 실패 계약서</th><td>' + this.contract.failCnt + ' 건</td></tr>'
      useMsg += ' </tbody></table>'
      defaultMsg = '<strong style="color: rgb(227, 61, 88);">성공한 업로드 건만 계약요청됩니다.</strong><p>계약 요청을 진행하시겠습니까?</p>' + useMsg

      this.$refs.confirm.open('confirm','사내 계약 요청',defaultMsg).then(() => {
        this.confirmPoint()
      })
    },

    // 기업 잔여 포인트 조회
    confirmPoint () {
      this.$refs.loading.start('기업의 포인트 조회중입니다')
      confirmUsePoint({ groupId: this.officeContractInfos[0].groupId }).then(response => {
        this.$refs.loading.end()
        if (response.rdata.rcode === 20000) {
          var totalPoint = response.rdata.totalPoint
          var usePoint = response.rdata.usePoint
          var afterUsePoint = response.rdata.afterUsePoint
          var calculPoint = totalPoint - usePoint
          var useMsg = null
          var defaultMsg = null

          useMsg = '<div class="row_mb-8">- 요금테이블</div>'
          useMsg += '<table class="basic_view">'
          useMsg += ' <colgroup><col style="width:40%"/><col style="width:60%"/></colgroup>'
          useMsg += ' <tbody>'
          useMsg += ' <tr><th scope="row">현재 Point</th><td>' + this.moneyCurrency(totalPoint) + 'P</td></tr>'
          useMsg += ' <tr><th scope="row">차감 Point</th><td>' + this.moneyCurrency(usePoint) + 'P [계약요청 ' + this.contract.sucCnt + ' 건]</td></tr>'
          useMsg += ' <tr><th scope="row">잔여 Point</th><td>' + this.moneyCurrency(afterUsePoint) + 'P</td></tr>'
          useMsg += ' </tbody></table>'

          if (calculPoint >= 0) {
            defaultMsg = '<strong style="color: #40bfda;">충전 Point에서 ' + this.moneyCurrency(usePoint) + 'Point 가 차감됩니다.</strong><p>계약 요청을 진행하시겠습니까?</p>' + useMsg
            this.$refs.confirm.open('confirm', '사내 계약 요청', defaultMsg).then(() => {
              this.dialogWcpn = true
            })
          } else {
            this.$refs.confirm.open('alert','사내계약', '포인트가 부족합니다. 충전후 사용해주세요.')
          }
        } else {
          this.$refs.confirm.open('alert','사내계약', '포인트 조회에 실패했습니다. ( error : ' + response.rdata.rmessage + ' )')
        }
      })
    },

    // 워터마크 첨부 눌렀을 때 호출 되는 함수
    openWmDialog () {
      this.$refs.loading.start('계약서 썸네일을 생성 중입니다.')

      this.firstCtrInfo.ctrFileName = this.successContract[0].contractFileNames[0]
      this.firstCtrInfo.qrcodeFileName = this.successContract[0].contractFileNames[1]
      this.firstCtrInfo.filePath = this.successContract[0].filePath
      this.firstCtrInfo.contractNumber = this.successContract[0].contractNumber
      this.firstCtrInfo.groupId = this.officeContractInfos[0].groupId

      pdfConversionRequestOfficeCtr(this.firstCtrInfo).then(response => {
        if (response.rdata.rcode === 20000) {
          this.convertedInfo.convertedCtrFileName = response.rdata.convertPdfName
          this.pdfFileName = response.rdata.convertPdfName

          this.createContractThumbnail()
          this.dialogWcpnWaterM = true
        } else {
          this.$refs.confirm.open('alert', '사내계약', 'error : ' + response.rdata.rmessage + ' )')
        }
      }).catch(e => {
        console.error(e)
      })
    },

    // 계약서 썸네일 생성
    createContractThumbnail () {
      this.$nextTick(() => {
        createContractThumbnail(JSON.stringify({ pdfFileName: this.pdfFileName })).then(response => {
          this.$refs.loading.end()
          this.contractThumbnail.pageSize = response.rdata.pdfPageSize
          for (var i = 0; i < this.contractThumbnail.pageSize; i++) {
            this.watermarks[i] = []
          }
          this.$forceUpdate()
          this.getContractThumbnail()
        }).catch(e => {
          console.log(e)
        })
      })
    },
    getContractThumbnail () {
      this.loading = false
      this.contractThumbnail.thumbnail.splice(0, this.contractThumbnail.thumbnail.length)
      for (let i = 0; i < this.contractThumbnail.pageSize; i++) {
        this.contractThumbnail.thumbnail.push(
          { url: URL.contractPageThumbnail + this.pdfFileName + '/' + i }
        )
      }
      this.deleteContractThumbnail()
    },

    // 워터마크 다이얼로그를 닫았을 때 생성됐던 썸네일 폴더 및 하위 파일들을 삭제해주는 기능
    deleteContractThumbnail () {
      setTimeout(() => {
        deleteContractThumbnail(JSON.stringify({ pdfFileName: this.pdfFileName })).then(response => {
          this.$forceUpdate()
        }).catch(e => {
        })
      }, 1000)
    },

    // 전자서명 등록
    registSignature () {
      var data = this.$refs.signature.save()
      if (data.data) {
        this.$refs.loading.start('전자 서명을 생성중입니다.')
        registSignature({ isWatermark: data.signToWatermark, activeName: this.signal, signBase64: data.data }).then(response => {
          this.$refs.loading.end()
          this.signVisible = false
          var currPageWmLength = 0
          this.showWm = true
          // 현재 swiper 페이지 인덱스
          var pageIndex = this.$refs.contractSwiper.swiper.realIndex
          var fileName = response.rdata.signFileName
          this.watermarks[pageIndex].push({ id: fileName, width: 100, height: 100, x: 0, y: 0, opacity: 100, isBarcode: 2, pageNum: pageIndex + 1 })
          // 이유는 모르겠으나.. 자동으로 2차원 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
          this.$forceUpdate()
          this.$nextTick(() => {
            currPageWmLength = this.getCurrPageWmLength()
            this.currIndex = currPageWmLength

            /* 동적으로 background-img를 넣어주는 부분 */
            var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + currPageWmLength)[0]
            pdfWatermark.style.width = this.watermarks[pageIndex][currPageWmLength].width + 'px'
            pdfWatermark.style.height = this.watermarks[pageIndex][currPageWmLength].height + 'px'
            pdfWatermark.style.backgroundSize = this.watermarks[pageIndex][currPageWmLength].width + 'px ' + this.watermarks[pageIndex][currPageWmLength].height + 'px'
            pdfWatermark.style.backgroundImage = 'url(' + URL.insertBarcode + fileName + ')'
            pdfWatermark.style.backgroundRepeat = 'no-repeat'
            this.selWmVisible = false

          })
        }).catch(e => {
          console.error(e)
        })
      }
    },

    // 전자서명 등록 Close
    signVisibleClose () {
      this.$refs.confirm.open('confirm', '전자서명', '현재 창을 닫으시면 작성한 전자서명이 지워집니다. 그래도 닫으시겠습니까?').then(() => {
        this.$refs.signature.initSignaturePad()
        this.signVisible = false
      })
    },

    // 워터마크 등록
    selectWatermark () {
      this.selWmVisible = true
      this.getWatermarkList()
    },

    // 워터마크 List 가져오는 메소드
    getWatermarkList () {
      this.$nextTick(() => {
        getWaterMarkList(JSON.stringify({ activeName: this.activeName })).then(response => {
          this.wmList = []
          for (var k in response.rdata.watermarks) {
            this.wmList.push({
              id: response.rdata.watermarks[k].watermarkSequence,
              url: URL.thumbnail + response.rdata.watermarks[k].watermarkSequence,
              originUrl: URL.watermark + response.rdata.watermarks[k].watermarkSequence
            })
          }
        }).catch(e => {
          console.log(e)
        })
      })
    },

    // 모든페이지 삽입 Button
    changeAllPageCheck (value) {
      var isCompareEachPage = false
      var firstPageWidth = document.getElementById('img-' + 0).clientWidth
      var firstPageHeight = document.getElementById('img-' + 0).clientHeight
      for (var i = 0; i < this.watermarks.length; i++) {
        var page = document.getElementById('img-' + i)
        if (firstPageWidth !== page.clientWidth && firstPageHeight !== page.clientHeight) {
          isCompareEachPage = true
          break
        }
      }
      if (isCompareEachPage) {
        this.$refs.confirm.open('alert', '워터마크 첨부', '업로드한 계약서의 각 페이지의 사이즈가 서로 달라서 모든 페이지 삽입 기능은 사용 할 수 없습니다.')
        this.contract.isAllPage = !value
      }
    },

    // 워터마크 초기화
    initWatermark () {
      this.showSlider = false
      // 올라가 있는 모든 워터마크 및 바코드 삭제
      this.$nextTick(() => {
        var pageIndex = this.$refs.contractSwiper.swiper.realIndex
        this.watermarks.splice(0, this.watermarks[pageIndex].length)
        for (var i = 0; i < this.contractThumbnail.pageSize; i++) {
          this.watermarks[i] = []
        }
        // 이유는 모르겠으나.. 자동으로 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
        this.$forceUpdate()
      })
    },

    // 페이지 마지막 부가정보 저장
    officeContractNextStep () {
      this.$store.dispatch("officeContractMetaStr",this.infos)
    },

    // 워터마크 다하고 나서 확인 눌렀을 때 호출되는 함수
    createWatermarkPdf () {
      this.$store.dispatch('convertPdfName', '')
      this.$store.dispatch('watermarkAttach', false)
      this.createContract()
      this.loopSleep()
    },

    // 계약서 발송
    createContract () {
      var paramWatermarks = []
      var pageRatios = []

      for (var i = 0; i < this.watermarks.length; i++) {
        for (var k = 0; k < this.watermarks[i].length; k++) {
          paramWatermarks.push(this.watermarks[i][k])
        }
        var page = document.getElementById('img-' + i)
        pageRatios.push({ page: i + 1, pageWidthRatio: 792 / page.clientWidth, pageHeightRatio: 1120 / page.clientHeight })
      }

      this.contract.contractPage = paramWatermarks
      this.contract.pdfFileName = this.pdfFileName
      this.contract.contractNum = this.contractNum
      this.contract.contractStatus = this.contractStatus
      this.contract.groupId = this.firstCtrInfo.groupId
      this.contract.pageRatios = pageRatios
      this.contract.addr = this.$store.state.user.useraddr

      if (paramWatermarks.length !== 0) {
        this.$refs.loading.start('계약서에 워터마크를 삽입중입니다.')

        createContract(JSON.stringify(this.contract)).then(response => {
          this.$refs.loading.end()
          if (response.rcode === 20000) {
            this.$store.dispatch('convertPdfName', response.rdata.convertPdfName)
            this.$store.dispatch('watermarkAttach', true)
            this.$refs.confirm.open('alert','계약서 생성 요청', '계약서파일 생성 요청에 성공했습니다.').then(() => {
              this.officeContractNextStep()
            })
          } else {
            this.$refs.confirm.open('alert','계약서 생성 요청', '계약서파일 생성 요청에 실패했습니다.')
          }
        }).catch(e => {
          this.$refs.confirm.open('alert','계약서 생성 요청', '계약서파일 생성 요청에 실패했습니다.')
        })
      } else {
        this.$store.dispatch('convertPdfName', 'empty')
        this.$store.dispatch('watermarkAttach', false)
        this.$refs.confirm.open('alert','계약서 생성 요청', '등록한 워터마크가 없어서 변환을 하지않습니다.')
        this.dialogWcpnWaterM = false
      }
    },

    // 서명/워터마크 첨부 Close
    closeWmDialog () {
      this.dialogWcpnWaterM = false
    },

    // get Current Page WaterMark Length
    getCurrPageWmLength () {
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      var currPageWmLength = 0
      for (var i = 0; i < this.watermarks.length; i++) {
        currPageWmLength += this.watermarks[i].length
      }
      currPageWmLength = currPageWmLength - (currPageWmLength - this.watermarks[pageIndex].length) - 1

      return currPageWmLength
    },

    // 워터마크 리사이즈
    onResize: function (x, y, width, height) {
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      this.$nextTick(() => {
        if (this.currIndex === null) {
          this.currIndex = 0
        }
        // pt
        this.watermarks[pageIndex][this.currIndex].x = x
        this.watermarks[pageIndex][this.currIndex].y = y

        // mm
        this.watermarks[pageIndex][this.currIndex].width = width
        this.watermarks[pageIndex][this.currIndex].height = height
        var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + this.currIndex)[0]
        pdfWatermark.style.width = width + 'px'
        pdfWatermark.style.height = height + 'px'
        pdfWatermark.style.backgroundSize = width + 'px ' + height + 'px'
      })
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      this.$nextTick(() => {
        this.watermarks[pageIndex][this.currIndex].x = x
        this.watermarks[pageIndex][this.currIndex].y = y
      })
    },

    // 워터마크 클릭 시
    onActive (index) {
      this.showSlider = true
      this.currIndex = index
      this.currPage = this.$refs.contractSwiper.swiper.realIndex
      this.opacity = this.watermarks[this.currPage][this.currIndex].opacity
    },
    // 워터마크 클릭이 해제됐을 때
    onDeactivate (index) {
    },

    // 워터마크 클릭시
    clickWm () {
      if(this.wmList.length < 1)
        return false;

      if(this.wmCheckedList.length < 1) {
        this.$refs.confirm.open('alert', '워터마크 등록', '등록할 워터마크를 선택해주세요.');
        return false;
      }

      var id =  this.wmList[this.wmCheckedList[0]].id;
      var url =   this.wmList[this.wmCheckedList[0]].url;

      // 선택한 워터마크 정보가져오기.
      this.showWm = true
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      this.watermarks[pageIndex].push({ id: id, width: 100, height: 100, x: 0, y: 0, opacity: 100, isBarcode: 0, pageNum: pageIndex + 1 })
      // 이유는 모르겠으나.. 자동으로 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
      this.$forceUpdate()
      this.$nextTick(() => {
        var currPageWmLength = 0
        currPageWmLength = this.getCurrPageWmLength()
        this.currIndex = currPageWmLength
        /* 동적으로 background-img를 넣어주는 부분 */
        var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + currPageWmLength)[0]

        pdfWatermark.style.width = this.watermarks[pageIndex][currPageWmLength].width + 'px'
        pdfWatermark.style.height = this.watermarks[pageIndex][currPageWmLength].height + 'px'
        pdfWatermark.style.backgroundSize = this.watermarks[pageIndex][currPageWmLength].width + 'px ' + this.watermarks[pageIndex][currPageWmLength].height + 'px'
        pdfWatermark.style.backgroundImage = 'url("' + url + '")'
        pdfWatermark.style.backgroundRepeat = 'no-repeat'
        this.selWmVisible = false
        // 워터마크 체크 초기화
        this.wmCheckedList = [];
      })
    },

    // 3자리 ,
    moneyCurrency (value) {
      if (!value) return '0'
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    },

    loopSleep () {
      setTimeout(() => {
        if (this.$store.state.app.convertPdfName) {
          this.isWmAttach = this.$store.state.app.watermarkAttach
        } else {
          this.loopSleep()
        }
      }, 500)
    },

    /** 첨부파일 */
    // chkPaperAttachFileUpload () {
    //   if (this.attachFiles.length > this.upload.uploadCtrPaperAttachExceed) {
		// 		this.$refs.confirm.open('alert', '', '총 ' + this.upload.uploadCtrPaperAttachExceed + '개의 파일까지 업로드 하실 수 있습니다.')
    //     // 첨부파일 임시 업로드 리스트, 파일정보 리스트 외에 업로드시 사용되는 리스트와 요소는 초기화
    //     this.upload.fileCtrPaperAttachList = []
    //     this.attachFiles = []
    //   }
    // },
  }
}
</script>
<style>
.PasFail_round_box {
  position: relative;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #cccccc;
  border-radius: 8px;
}

.PasFail_Con {
  padding-left: 0 !important;
  width: calc(100% - 200px);
  font-size: .8rem;
  color: #434846;
  vertical-align: top;
}
.contractRe_con{
  position: relative;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #cccccc;
}
.inputH48_01.WaddWCpn .v-input__slot {
  margin-right: 14px;
  width: calc(100% - 54px);
}
.btn_addWCpn_cerList {
  position: absolute;
  top: 10px;
  right: 0px;
  padding: 0 !important;
  height: 48px !important;
  font-size: .75rem !important;
  color: #fff !important;
  background-color: #31c964 !important;
  border-radius: 7px;
}
.v-chip.pasFail-chip {
  display: inline-block;
  margin-right: 10px;
  height: 1.2rem;
  font-size: .6rem !important;
  font-weight: 300 !important;
  background: transparent !important;
  color: #68c232 !important;
  border: solid 1px #68c232;
  vertical-align: middle;
}

.v-chip.pasFail-chip.stFail {
  color: #ff7666 !important;
  border-color: #ff7666 !important;
}

.v-chip.pasFail-chip.stSuccess {
  color: #68c232 !important;
  border-color: #68c232 !important;
}

.PasFail_Con li {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 6px;
  min-height: 24px;
  vertical-align: middle;
}

.PasFail_Con li:last-child {
  margin-right: 0;
}

.PasFail_Con li .txt_txt01 {
  padding-right: 8px;
  font-size: .75rem;
  color: #989898;
  font-weight: 100;
  vertical-align: middle;
}

.PasFail_Con li .txt_txt02 {
  font-size: .7rem;
  color: #989898;
  font-weight: 100;
  vertical-align: middle;
}
.PasFail_ConN_btn {
    position: absolute;
    right: 0;
    top: -10px;
}
@media (max-width: 959px) {
  .PasFail_Con{
    width: 100%;
    margin-bottom: 20px;
  }
  .PasFail_ConN_btn {
    position: relative;
    right: auto;
    top: auto;
    margin: 0;
  }
}
/*pasFail_list*/
.pasFail_list {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    max-height: 40vh;
    overflow: hidden;
    overflow-y: auto;
    border-top: 1px solid #d7d8da;
    border-bottom: 1px solid #d7d8da;
}
.pasFail_carD {
    position: relative;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    box-sizing: border-box;
    margin-bottom: 6px;
    padding: 6px 20px;
    height: auto;
    overflow: hidden;
    border: 1px solid #ccc !important;
    border-radius: 16px !important;
}
.pasFail_list .col.pFlist_num {
  flex: 0 0 2em;
  max-width: 2em;
  font-size: .9rem !important;
  color: #989898;
}
.pasFail_list .row_01 {
  position: relative;
  padding: 0;
  width: 100%;
  line-height: 1.24em;
  min-height: 0;
  font-size: .9rem !important;
  color: #353535 !important;
}
.pasFail_list .carD_chip00 {
  display: inline-block;
  margin-right: 10px;
  width: auto;
  vertical-align: top;
  text-align: center;
}
.pasFail_list .txt_01 {
  vertical-align: middle;
  display: inline-block;
  width: auto;
  font-size: .75rem;
  color: #2b2d2c;
  word-break: break-all;
  font-weight: 300;
}
.pasFail_list .row_02 {
  margin-top: 6px;
  padding: 0;
  min-height: 0 !important;
}
.pasFail_list .row_02 .pattern_ulTxtBox li .txt_txt01 {
  font-size:.6rem;
}
.pasFail_list .col.btnCon_pFlist-del{
  flex: 0 0 60px;
  max-width: 60px;
  text-align: right;
}
.list_no_txt02{
  margin-bottom: 20px;
  padding: 20px 0;
  width: 100%;
  font-size: .8rem;
  color: #a4a5a9;
  font-weight: 400;
  vertical-align: middle;
  text-align: center;
  border-top: 1px solid #d7d8da;
  border-bottom: 1px solid #d7d8da;
}
@media (max-width: 959px) {
  .pasFail_list{
    max-height: 60vh;
  }
  .pasFail_list .col.btnCon_pFlist-del{
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (max-width: 640px) {
  .pasFail_list .col.pFlist_num {
    margin-bottom: 8px;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .pasFail_list .col.pFlist_con{
    flex: 0 0 100%;
    max-width: 100%;
  }
}
/*/pasFail_list*/

/* 기존 v1 css */
.basic_view{width:100%; border-spacing: 0; border-top:1px solid #dbdce1;}
.basic_view tbody{border-top:1px solid #dbdce1;}
.basic_view td,.basic_view th{font-size:14px;line-height:1.3em;}
.basic_view th{padding:16px 0 15px 30px;border-bottom:1px solid #dbdce1;border-right:1px solid #dbdce1;background-color:#f4f5fa;color:#96979b;font-size:14px;font-weight:400;text-align:left;vertical-align:middle;}
.basic_view td{padding:10px 0 10px 20px;vertical-align:middle;border-bottom:1px solid #dbdce1;}
.basic_view .bdl{border-left:1px solid #dbdce1;}
.basic_view th.textc{padding:12px 0 11px 0;text-align:center;}
</style>
